// hooks/useCRMPermissionCheck.js
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectCRMPermissions, setUserCRM, selectCurrentCRM, switchCRM } from 'store/features/users/userSlice';

const useCRMPermissionCheck = () => {
  const dispatch = useDispatch();
  const userId = useSelector(state => state.auth.user?.id);
  const token = process.env.REACT_APP_TOKEN;

  // Get current state from Redux
  const currentPermissions = useSelector(selectCRMPermissions);
  const currentCRM = useSelector(selectCurrentCRM);

  useEffect(() => {
    const checkPermissions = async () => {
      if (!userId) return;

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}qwikITUser/${userId}`,
          {
            method: 'GET',
            headers: {
              'Authorization': `${token}`,
              'Content-Type': 'application/json',
            },
          }
        );

        if (response.ok) {
          const latestUserData = await response.json();
          const latestPermissions = latestUserData?.crm_permissions || [];
          const latestDefaultCRM = latestUserData?.default_crm;

          console.log("Latest permissions:", latestPermissions);
          console.log("Current permissions:", currentPermissions);

          // Check if permissions have changed
          // const permissionsChanged =
          //   JSON.stringify(latestPermissions.sort()) !==
          //   JSON.stringify(currentPermissions.sort());

          const permissionsChanged =
            latestPermissions.length !== currentPermissions.length ||
            latestPermissions.some(p => !currentPermissions.includes(p));



          if (permissionsChanged) {
            console.log('CRM permissions updated');

            // Update Redux store with latest permissions
            dispatch(setUserCRM({
              default_crm: latestDefaultCRM,
              crm_permissions: latestPermissions,
            }));

            // If current CRM is no longer accessible, switch to default CRM
            if (currentCRM && !latestPermissions.includes(currentCRM)) {
              console.log('Current CRM no longer accessible, switching to default');
              dispatch(switchCRM(latestDefaultCRM || latestPermissions[0]));
            }
          }
        }
      } catch (error) {
        console.error('Error checking CRM permissions:', error);
      }
    };

    // Check on initial load
    checkPermissions();

    // Optional: Set up interval to check periodically (e.g., every 5 minutes)
    const intervalId = setInterval(checkPermissions, 5 * 60 * 1000);

    return () => clearInterval(intervalId);
  }, [userId, token, dispatch, currentPermissions, currentCRM]);

  return null;
};

export default useCRMPermissionCheck;